import React from "react";
import type { Training } from "../../../../api/training/Training.typed";
import type { ZekayCustomer } from "../../../../api/customers/Customer.typed";

type GetCustomerFn = (id: string) => Promise<ZekayCustomer | undefined>;
type ShowAlertFn = (
  message: string,
  color: "warning" | "danger" | "success" | "primary" | "neutral",
) => void;

type Params = {
  training: Training;
  initialCustomer?: ZekayCustomer;
  getCustomer: GetCustomerFn;
  showAlert: ShowAlertFn;
};

export function useTrainingCustomerProfile({
  training,
  initialCustomer,
  getCustomer,
  showAlert,
}: Params) {
  const [customer, setCustomer] = React.useState<ZekayCustomer | undefined>(initialCustomer);
  const [profileFormOpen, setProfileFormOpen] = React.useState(false);

  React.useEffect(() => {
    if (initialCustomer?.Id === training?.CustomerID) {
      setCustomer(initialCustomer);
      return;
    }
    if (!training?.CustomerID) return;
    let mounted = true;
    getCustomer(String(training.CustomerID)).then((c) => {
      if (mounted) setCustomer(c);
    });
    return () => {
      mounted = false;
    };
  }, [training?.CustomerID, getCustomer, initialCustomer]);

  const openProfile = React.useCallback(async () => {
    if (!training.CustomerID) {
      showAlert("ID client manquant", "warning");
      return;
    }
    if (customer) {
      setProfileFormOpen(true);
      return;
    }
    const fetchedCustomer = await getCustomer(String(training.CustomerID));
    setCustomer(fetchedCustomer);
    setProfileFormOpen(true);
  }, [customer, training.CustomerID, getCustomer, showAlert]);

  return {
    customer,
    setCustomer,
    profileFormOpen,
    setProfileFormOpen,
    openProfile,
  };
}
